import React from 'react';
import { Trash2 } from 'lucide-react';
import { toast } from 'sonner';
import { api, errText } from '@/lib/api';
import { Button } from '@/components/ui/button';
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from '@/components/ui/alert-dialog';

export function DeleteCampaignButton({ campaign, onDeleted }) {
  const remove = async () => {
    try {
      await api.delete(`/campaigns/${campaign.id}`);
      toast.success('Evento eliminado');
      onDeleted();
    } catch (e) {
      toast.error(errText(e, 'No se pudo eliminar'));
    }
  };
  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <Button variant="outline" size="sm" className="text-red-300" data-testid="campaign-delete-button">
          <Trash2 className="h-4 w-4 mr-1" />Eliminar evento
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>¿Eliminar “{campaign.name}”?</AlertDialogTitle>
          <AlertDialogDescription>Se borrarán el evento y sus {campaign.counts?.total ?? 0} congregaciones con su historial. No se puede deshacer.</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="campaign-delete-cancel">Cancelar</AlertDialogCancel>
          <AlertDialogAction onClick={remove} data-testid="campaign-delete-confirm">Eliminar</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
